import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Spinner, Card, Row, Col, Badge } from "react-bootstrap";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";

const UserLink = ({ user }) => {
  if (!user) return <Badge bg="secondary">N/A</Badge>;
  return (
    <Link to={`/usersdata?userId=${user._id}`} className="d-flex align-items-center gap-2">
      <img 
        src={user.profile_pic} 
        alt={user.username} 
        style={{ width: 25, height: 25, borderRadius: '50%', objectFit: 'cover' }} 
      />
      {user.username || user.email}
    </Link>
  );
};

const AuctionDataDetail = () => {
  const { id } = useParams();
  const [auction, setAuction] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAuction = async () => {
      setLoading(true);
      try {
        const res = await apiClient.get(`/data/auctions/${id}`);
        if (res.data && res.data.status) {
          setAuction(res.data.data);
        } else {
          toast.error("Failed to fetch auction details.");
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "An error occurred.");
      } finally {
        setLoading(false);
      }
    };
    fetchAuction();
  }, [id]);

  if (loading) {
    return <Spinner animation="border" />;
  }

  if (!auction) {
    return <h2>Auction not found.</h2>;
  }

  const renderField = (key, value) => {
    if (!value) return <Badge bg="secondary">null</Badge>;

    if (Array.isArray(value) && value.length > 0 && value[0].username) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
          {value.map(user => <UserLink key={user._id} user={user} />)}
        </div>
      );
    }

    if (typeof value === 'object' && value.username) {
      return <UserLink user={value} />;
    }

    if (Array.isArray(value)) {
      return <pre>{JSON.stringify(value, null, 2)}</pre>;
    }

    if (typeof value === 'object') {
      return <pre>{JSON.stringify(value, null, 2)}</pre>;
    }

    return value.toString();
  };

  return (
    <div className="container-fluid p-4">
        <button style={{
            position: 'fixed',
            right: '10px',
        }} 
        onClick={() => navigate('/auctionsdata')}
        >back to overview</button>
      <h2 className="mb-4">{auction.item_name}</h2>
      <Row>
        <Col md={8}>
          <Card>
            <Card.Header><h4>All Auction Fields</h4></Card.Header>
            <Card.Body>
              {Object.entries(auction).map(([key, value]) => (
                <Row key={key} className="border-bottom py-2">
                  <Col md={4}><strong>{key}</strong></Col>
                  <Col md={8}>{renderField(key, value)}</Col>
                </Row>
              ))}
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <Card.Header><h4>Key Info</h4></Card.Header>
            <Card.Body>
              <p><strong>Seller:</strong> <UserLink user={auction.created_by} /></p>
              <p><strong>Sold To:</strong> <UserLink user={auction.sold_to} /></p>
              <p><strong>Category:</strong> {auction.category?.name}</p>
              <p><strong>Starting Bid:</strong> ${auction.starting_bid}</p>
              <p><strong>Sold Price:</strong> ${auction.sold_price || 'N/A'}</p>
              <p><strong>Status:</strong> {auction.is_draft ? "Draft" : (auction.item_sold ? "Sold" : "Live/Ended")}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AuctionDataDetail;